"use strict";
exports.__esModule = true;
exports.Api = void 0;
var tslib_1 = require("tslib");
/* tslint:disable */
/* eslint:disable */
require("isomorphic-fetch");
var ApiError = /** @class */ (function () {
    function ApiError(message) {
        this.details = null;
        this.message = message;
    }
    return ApiError;
}());
/**
 *
 * @class Api
 * @param {(string)} [domainOrOptions] - The project domain.
 */
var Api = /** @class */ (function () {
    function Api() {
        this.baseUrl = '';
    }
    Api.prototype.serializeQueryParams = function (parameters) {
        return Object.keys(parameters)
            .reduce(function (acc, p) {
            var param = parameters[p];
            if (typeof param === 'undefined' || param === '') {
                return acc;
            }
            return tslib_1.__spreadArrays(acc, [
                encodeURIComponent(p) + "=" + encodeURIComponent(String(parameters[p])),
            ]);
        }, [])
            .join('&');
    };
    Api.prototype.transformParameter = function (value, transformOperation) {
        switch (transformOperation) {
            case 'joinUsingPipes':
                return Array.isArray(value) ? value.join('|') : value;
            default:
                return value;
        }
    };
    Api.prototype.setBaseUrl = function (baseUrl) {
        this.baseUrl = baseUrl;
    };
    Api.prototype.appendAuthHeaders = function (headerParams) {
        var headers = new Headers(headerParams);
        return headers;
    };
    Api.prototype.request = function (method, url, body, headers, queryParameters) {
        if (headers === void 0) { headers = new Headers(); }
        if (queryParameters === void 0) { queryParameters = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryParams, urlWithParams, form, k, response, responseContentType, err, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        queryParams = queryParameters && Object.keys(queryParameters).length
                            ? this.serializeQueryParams(queryParameters)
                            : null;
                        urlWithParams = url + (queryParams ? '?' + queryParams : '');
                        if (headers.get('Content-Type') === 'multipart/form-data') {
                            form = new FormData();
                            for (k in body) {
                                form.append(k, body[k]);
                            }
                            body = form;
                        }
                        else if (headers.get('Content-Type') === 'application/json' &&
                            body &&
                            Object.keys(body).length > 0) {
                            body = JSON.stringify(body);
                        }
                        else {
                            body = undefined;
                        }
                        if (headers.get('Content-Type') === 'multipart/form-data') {
                            headers["delete"]('Content-Type');
                        }
                        return [4 /*yield*/, fetch(urlWithParams, { method: method, headers: headers, body: body })];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) return [3 /*break*/, 2];
                        responseContentType = (response.headers && response.headers.get('Content-Type')) || '';
                        if (responseContentType.includes('application/json')) {
                            return [2 /*return*/, response.json()];
                        }
                        else if (responseContentType.includes('application/pdf')) {
                            return [2 /*return*/, response.blob()];
                        }
                        else if (responseContentType.includes('text/plain')) {
                            return [2 /*return*/, response.text()];
                        }
                        return [2 /*return*/, {}];
                    case 2:
                        err = new ApiError(response.statusText);
                        _a = err;
                        return [4 /*yield*/, response.json()];
                    case 3:
                        _a.details = _b.sent();
                        throw err;
                }
            });
        });
    };
    /**
     * Get Contentspace Details
     * @method
     * @name Api#publicGetSettings
     */
    Api.prototype.publicGetSettings = function (appSpace, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/settings';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getCompetitions
     */
    Api.prototype.getCompetitions = function (appSpace, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/competitions';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        queryParameters['limit'] = 100;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        if (typeof parameters['seasonId'] !== 'undefined') {
            queryParameters['seasonId'] = parameters['seasonId'];
        }
        queryParameters['seasonId'] = this.transformParameter(queryParameters['seasonId']);
        if (typeof parameters['q'] !== 'undefined') {
            queryParameters['q'] = parameters['q'];
        }
        queryParameters['q'] = this.transformParameter(queryParameters['q']);
        path = path.replace('{appSpace}', appSpace.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getCompetitionGroupById
     */
    Api.prototype.getCompetitionGroupById = function (appSpace, competitionGroupId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/competition-groups/{competitionGroupId}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{competitionGroupId}', competitionGroupId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getCompetitionById
     */
    Api.prototype.getCompetitionById = function (appSpace, competitionId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/competitions/{competitionId}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{competitionId}', competitionId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getCompetitionParts
     */
    Api.prototype.getCompetitionParts = function (appSpace, competitionId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/competitions/{competitionId}/parts';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{competitionId}', competitionId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getCompetitionPartById
     */
    Api.prototype.getCompetitionPartById = function (appSpace, competitionId, partId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/competitions/{competitionId}/parts/{partId}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['roundId'] !== 'undefined') {
            queryParameters['roundId'] = parameters['roundId'];
        }
        queryParameters['roundId'] = this.transformParameter(queryParameters['roundId']);
        if (typeof parameters['omitResultsTable'] !== 'undefined') {
            queryParameters['omitResultsTable'] = parameters['omitResultsTable'];
        }
        queryParameters['omitResultsTable'] = this.transformParameter(queryParameters['omitResultsTable']);
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{competitionId}', competitionId.toString());
        path = path.replace('{partId}', partId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getCompetitionPartMatches
     */
    Api.prototype.getCompetitionPartMatches = function (appSpace, competitionId, partId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/competitions/{competitionId}/parts/{partId}/matches';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        queryParameters['limit'] = 100;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        if (typeof parameters['roundId'] !== 'undefined') {
            queryParameters['roundId'] = parameters['roundId'];
        }
        queryParameters['roundId'] = this.transformParameter(queryParameters['roundId']);
        if (typeof parameters['dateBefore'] !== 'undefined') {
            queryParameters['dateBefore'] = parameters['dateBefore'];
        }
        queryParameters['dateBefore'] = this.transformParameter(queryParameters['dateBefore']);
        if (typeof parameters['dateAfter'] !== 'undefined') {
            queryParameters['dateAfter'] = parameters['dateAfter'];
        }
        queryParameters['dateAfter'] = this.transformParameter(queryParameters['dateAfter']);
        if (typeof parameters['withDate'] !== 'undefined') {
            queryParameters['withDate'] = parameters['withDate'];
        }
        queryParameters['withDate'] = this.transformParameter(queryParameters['withDate']);
        if (typeof parameters['withTeams'] !== 'undefined') {
            queryParameters['withTeams'] = parameters['withTeams'];
        }
        queryParameters['withTeams'] = this.transformParameter(queryParameters['withTeams']);
        if (typeof parameters['closed'] !== 'undefined') {
            queryParameters['closed'] = parameters['closed'];
        }
        queryParameters['closed'] = this.transformParameter(queryParameters['closed']);
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{competitionId}', competitionId.toString());
        path = path.replace('{partId}', partId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getCompetitionMatches
     */
    Api.prototype.getCompetitionMatches = function (appSpace, competitionId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/competitions/{competitionId}/matches';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        queryParameters['limit'] = 100;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        if (typeof parameters['closed'] !== 'undefined') {
            queryParameters['closed'] = parameters['closed'];
        }
        queryParameters['closed'] = this.transformParameter(queryParameters['closed']);
        if (typeof parameters['dateBefore'] !== 'undefined') {
            queryParameters['dateBefore'] = parameters['dateBefore'];
        }
        queryParameters['dateBefore'] = this.transformParameter(queryParameters['dateBefore']);
        if (typeof parameters['dateAfter'] !== 'undefined') {
            queryParameters['dateAfter'] = parameters['dateAfter'];
        }
        queryParameters['dateAfter'] = this.transformParameter(queryParameters['dateAfter']);
        if (typeof parameters['withTeams'] !== 'undefined') {
            queryParameters['withTeams'] = parameters['withTeams'];
        }
        queryParameters['withTeams'] = this.transformParameter(queryParameters['withTeams']);
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{competitionId}', competitionId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getMatchResultsTable
     */
    Api.prototype.getMatchResultsTable = function (matchId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/matches/{matchId}/results';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{matchId}', matchId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getMatchVarEvents
     */
    Api.prototype.getMatchVarEvents = function (matchId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/matches/{matchId}/varevents';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{matchId}', matchId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getAllTeams
     */
    Api.prototype.getAllTeams = function (parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/teams';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['q'] !== 'undefined') {
            queryParameters['q'] = parameters['q'];
        }
        queryParameters['q'] = this.transformParameter(queryParameters['q']);
        if (typeof parameters['seasonIds'] !== 'undefined') {
            queryParameters['season_ids'] = parameters['seasonIds'];
        }
        queryParameters['season_ids'] = this.transformParameter(queryParameters['season_ids']);
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getTeams
     */
    Api.prototype.getTeams = function (appSpace, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/teams';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        queryParameters['limit'] = 100;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        if (typeof parameters['seasonIds'] !== 'undefined') {
            queryParameters['season_ids'] = parameters['seasonIds'];
        }
        queryParameters['season_ids'] = this.transformParameter(queryParameters['season_ids']);
        path = path.replace('{appSpace}', appSpace.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getTeam
     */
    Api.prototype.getTeam = function (appSpace, teamId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/teams/{teamId}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{teamId}', teamId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#publicGetTeamSquad
     */
    Api.prototype.publicGetTeamSquad = function (appSpace, teamId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/teams/{teamId}/squad';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{teamId}', teamId.toString());
        if (typeof parameters['date'] !== 'undefined') {
            queryParameters['date'] = parameters['date'];
        }
        queryParameters['date'] = this.transformParameter(queryParameters['date']);
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getTeamCompetitions
     */
    Api.prototype.getTeamCompetitions = function (appSpace, teamId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/teams/{teamId}/competitions';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['seasonId'] !== 'undefined') {
            queryParameters['seasonId'] = parameters['seasonId'];
        }
        queryParameters['seasonId'] = this.transformParameter(queryParameters['seasonId']);
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{teamId}', teamId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getTeamCompetition
     */
    Api.prototype.getTeamCompetition = function (appSpace, teamId, competitionId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/teams/{teamId}/competitions/{competitionId}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{teamId}', teamId.toString());
        path = path.replace('{competitionId}', competitionId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getTeamCompetitionMatches
     */
    Api.prototype.getTeamCompetitionMatches = function (appSpace, teamIds, competitionId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/teams/{teamIds}/competitions/{competitionId}/matches';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{teamIds}', teamIds.toString());
        path = path.replace('{competitionId}', competitionId.toString());
        queryParameters['limit'] = 100;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        if (typeof parameters['closed'] !== 'undefined') {
            queryParameters['closed'] = parameters['closed'];
        }
        queryParameters['closed'] = this.transformParameter(queryParameters['closed']);
        if (typeof parameters['dateBefore'] !== 'undefined') {
            queryParameters['dateBefore'] = parameters['dateBefore'];
        }
        queryParameters['dateBefore'] = this.transformParameter(queryParameters['dateBefore']);
        if (typeof parameters['dateAfter'] !== 'undefined') {
            queryParameters['dateAfter'] = parameters['dateAfter'];
        }
        queryParameters['dateAfter'] = this.transformParameter(queryParameters['dateAfter']);
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     * Get Club Played Years
     * @method
     * @name Api#getDistinctClubPlayedYears
     */
    Api.prototype.getDistinctClubPlayedYears = function (appSpace, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/played-years';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     * Get Team Played Years
     * @method
     * @name Api#getDistinctTeamPlayedYears
     */
    Api.prototype.getDistinctTeamPlayedYears = function (appSpace, teamId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/{appSpace}/teams/{teamId}/played-years';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{teamId}', teamId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getMatch
     */
    Api.prototype.getMatch = function (matchId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/matches/{matchId}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['noCache'] !== 'undefined') {
            queryParameters['noCache'] = parameters['noCache'];
        }
        queryParameters['noCache'] = this.transformParameter(queryParameters['noCache']);
        path = path.replace('{matchId}', matchId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getSettingById
     */
    Api.prototype.getSettingById = function (settingId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/settings/{settingId}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{settingId}', settingId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getSettingBySportSector
     */
    Api.prototype.getSettingBySportSector = function (settingId, sectorId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/settings/{settingId}/sector/{sectorId}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{settingId}', settingId.toString());
        path = path.replace('{sectorId}', sectorId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getAllCompetitionGroups
     */
    Api.prototype.getAllCompetitionGroups = function (parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/competition-groups';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['appSpaces'] !== 'undefined') {
            queryParameters['appSpaces'] = parameters['appSpaces'];
        }
        queryParameters['appSpaces'] = this.transformParameter(queryParameters['appSpaces']);
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getAllCompetitions
     */
    Api.prototype.getAllCompetitions = function (parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/competitions';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        if (typeof parameters['q'] !== 'undefined') {
            queryParameters['q'] = parameters['q'];
        }
        queryParameters['q'] = this.transformParameter(queryParameters['q']);
        if (typeof parameters['appSpace'] !== 'undefined') {
            queryParameters['appSpace'] = parameters['appSpace'];
        }
        queryParameters['appSpace'] = this.transformParameter(queryParameters['appSpace']);
        if (typeof parameters['ownerPpo'] !== 'undefined') {
            queryParameters['ownerPPO'] = parameters['ownerPpo'];
        }
        queryParameters['ownerPPO'] = this.transformParameter(queryParameters['ownerPPO']);
        if (typeof parameters['format'] !== 'undefined') {
            queryParameters['format'] = parameters['format'];
        }
        queryParameters['format'] = this.transformParameter(queryParameters['format']);
        if (typeof parameters['type'] !== 'undefined') {
            queryParameters['type'] = parameters['type'];
        }
        queryParameters['type'] = this.transformParameter(queryParameters['type']);
        if (typeof parameters['seasonName'] !== 'undefined') {
            queryParameters['seasonName'] = parameters['seasonName'];
        }
        queryParameters['seasonName'] = this.transformParameter(queryParameters['seasonName']);
        if (typeof parameters['seasonNames'] !== 'undefined') {
            queryParameters['seasonNames'] = parameters['seasonNames'];
        }
        queryParameters['seasonNames'] = this.transformParameter(queryParameters['seasonNames']);
        if (typeof parameters['date'] !== 'undefined') {
            queryParameters['date'] = parameters['date'];
        }
        queryParameters['date'] = this.transformParameter(queryParameters['date']);
        if (typeof parameters['teamIds'] !== 'undefined') {
            queryParameters['teamIds'] = parameters['teamIds'];
        }
        queryParameters['teamIds'] = this.transformParameter(queryParameters['teamIds'], 'joinUsingPipes');
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getPublicCompetitionPartById
     */
    Api.prototype.getPublicCompetitionPartById = function (competitionId, partId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/competitions/{competitionId}/parts/{partId}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['roundId'] !== 'undefined') {
            queryParameters['roundId'] = parameters['roundId'];
        }
        queryParameters['roundId'] = this.transformParameter(queryParameters['roundId']);
        path = path.replace('{competitionId}', competitionId.toString());
        path = path.replace('{partId}', partId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getMatches
     */
    Api.prototype.getMatches = function (parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/matches';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['noCache'] !== 'undefined') {
            queryParameters['noCache'] = parameters['noCache'];
        }
        queryParameters['noCache'] = this.transformParameter(queryParameters['noCache']);
        if (typeof parameters['playerAppSpace'] !== 'undefined') {
            queryParameters['playerAppSpace'] = parameters['playerAppSpace'];
        }
        queryParameters['playerAppSpace'] = this.transformParameter(queryParameters['playerAppSpace']);
        if (typeof parameters['playerId'] !== 'undefined') {
            queryParameters['playerId'] = parameters['playerId'];
        }
        queryParameters['playerId'] = this.transformParameter(queryParameters['playerId']);
        if (typeof parameters['competitionGroupId'] !== 'undefined') {
            queryParameters['competitionGroupId'] = parameters['competitionGroupId'];
        }
        queryParameters['competitionGroupId'] = this.transformParameter(queryParameters['competitionGroupId']);
        if (typeof parameters['competitionId'] !== 'undefined') {
            queryParameters['competitionId'] = parameters['competitionId'];
        }
        queryParameters['competitionId'] = this.transformParameter(queryParameters['competitionId']);
        if (typeof parameters['partId'] !== 'undefined') {
            queryParameters['partId'] = parameters['partId'];
        }
        queryParameters['partId'] = this.transformParameter(queryParameters['partId']);
        if (typeof parameters['roundId'] !== 'undefined') {
            queryParameters['roundId'] = parameters['roundId'];
        }
        queryParameters['roundId'] = this.transformParameter(queryParameters['roundId']);
        if (typeof parameters['dateFrom'] !== 'undefined') {
            queryParameters['dateFrom'] = parameters['dateFrom'];
        }
        queryParameters['dateFrom'] = this.transformParameter(queryParameters['dateFrom']);
        if (typeof parameters['dateTo'] !== 'undefined') {
            queryParameters['dateTo'] = parameters['dateTo'];
        }
        queryParameters['dateTo'] = this.transformParameter(queryParameters['dateTo']);
        if (typeof parameters['withDate'] !== 'undefined') {
            queryParameters['withDate'] = parameters['withDate'];
        }
        queryParameters['withDate'] = this.transformParameter(queryParameters['withDate']);
        if (typeof parameters['withTeams'] !== 'undefined') {
            queryParameters['withTeams'] = parameters['withTeams'];
        }
        queryParameters['withTeams'] = this.transformParameter(queryParameters['withTeams']);
        if (typeof parameters['closed'] !== 'undefined') {
            queryParameters['closed'] = parameters['closed'];
        }
        queryParameters['closed'] = this.transformParameter(queryParameters['closed']);
        if (typeof parameters['teamId'] !== 'undefined') {
            queryParameters['teamId'] = parameters['teamId'];
        }
        queryParameters['teamId'] = this.transformParameter(queryParameters['teamId']);
        if (typeof parameters['seasonName'] !== 'undefined') {
            queryParameters['seasonName'] = parameters['seasonName'];
        }
        queryParameters['seasonName'] = this.transformParameter(queryParameters['seasonName']);
        if (typeof parameters['ids'] !== 'undefined') {
            queryParameters['ids'] = parameters['ids'];
        }
        queryParameters['ids'] = this.transformParameter(queryParameters['ids']);
        if (typeof parameters['excludeIds'] !== 'undefined') {
            queryParameters['excludeIds'] = parameters['excludeIds'];
        }
        queryParameters['excludeIds'] = this.transformParameter(queryParameters['excludeIds'], 'joinUsingPipes');
        if (typeof parameters['teamAppSpaces'] !== 'undefined') {
            queryParameters['teamAppSpaces'] = parameters['teamAppSpaces'];
        }
        queryParameters['teamAppSpaces'] = this.transformParameter(queryParameters['teamAppSpaces'], 'joinUsingPipes');
        if (typeof parameters['teamIds'] !== 'undefined') {
            queryParameters['teamIds'] = parameters['teamIds'];
        }
        queryParameters['teamIds'] = this.transformParameter(queryParameters['teamIds'], 'joinUsingPipes');
        if (typeof parameters['allTeamIds'] !== 'undefined') {
            queryParameters['allTeamIds'] = parameters['allTeamIds'];
        }
        queryParameters['allTeamIds'] = this.transformParameter(queryParameters['allTeamIds'], 'joinUsingPipes');
        if (typeof parameters['appSpace'] !== 'undefined') {
            queryParameters['appSpace'] = parameters['appSpace'];
        }
        queryParameters['appSpace'] = this.transformParameter(queryParameters['appSpace']);
        if (typeof parameters['smarttagsAppSpace'] !== 'undefined') {
            queryParameters['smarttagsAppSpace'] = parameters['smarttagsAppSpace'];
        }
        queryParameters['smarttagsAppSpace'] = this.transformParameter(queryParameters['smarttagsAppSpace']);
        if (typeof parameters['smarttags'] !== 'undefined') {
            queryParameters['smarttags'] = parameters['smarttags'];
        }
        queryParameters['smarttags'] = this.transformParameter(queryParameters['smarttags'], 'joinUsingPipes');
        if (typeof parameters['rulesSportSector'] !== 'undefined') {
            queryParameters['rulesSportSector'] = parameters['rulesSportSector'];
        }
        queryParameters['rulesSportSector'] = this.transformParameter(queryParameters['rulesSportSector']);
        if (typeof parameters['managerRoles'] !== 'undefined') {
            queryParameters['managerRoles'] = parameters['managerRoles'];
        }
        queryParameters['managerRoles'] = this.transformParameter(queryParameters['managerRoles']);
        if (typeof parameters['sorter'] !== 'undefined') {
            queryParameters['sorter'] = parameters['sorter'];
        }
        queryParameters['sorter'] = this.transformParameter(queryParameters['sorter']);
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        queryParameters['limit'] = 20;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getH2HMatches
     */
    Api.prototype.getH2HMatches = function (parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/h2h-matches';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['competitionGroupId'] !== 'undefined') {
            queryParameters['competitionGroupId'] = parameters['competitionGroupId'];
        }
        queryParameters['competitionGroupId'] = this.transformParameter(queryParameters['competitionGroupId']);
        if (typeof parameters['dateFrom'] !== 'undefined') {
            queryParameters['dateFrom'] = parameters['dateFrom'];
        }
        queryParameters['dateFrom'] = this.transformParameter(queryParameters['dateFrom']);
        if (typeof parameters['dateTo'] !== 'undefined') {
            queryParameters['dateTo'] = parameters['dateTo'];
        }
        queryParameters['dateTo'] = this.transformParameter(queryParameters['dateTo']);
        if (typeof parameters['closed'] !== 'undefined') {
            queryParameters['closed'] = parameters['closed'];
        }
        queryParameters['closed'] = this.transformParameter(queryParameters['closed']);
        if (typeof parameters['excludeIds'] !== 'undefined') {
            queryParameters['excludeIds'] = parameters['excludeIds'];
        }
        queryParameters['excludeIds'] = this.transformParameter(queryParameters['excludeIds'], 'joinUsingPipes');
        if (typeof parameters['teamAppSpaces'] !== 'undefined') {
            queryParameters['teamAppSpaces'] = parameters['teamAppSpaces'];
        }
        queryParameters['teamAppSpaces'] = this.transformParameter(queryParameters['teamAppSpaces'], 'joinUsingPipes');
        queryParameters['limit'] = 20;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getLastRoundMatches
     */
    Api.prototype.getLastRoundMatches = function (competitionId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/competitions/{competitionId}/last-round-matches';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        path = path.replace('{competitionId}', competitionId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getH2HStats
     */
    Api.prototype.getH2HStats = function (teamIds, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/public/h2h/{teamIds}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{teamIds}', teamIds.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getPlayerMatches
     */
    Api.prototype.getPlayerMatches = function (appSpace, sportnetId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/player-matches/ppo/{appSpace}/player/{sportnetId}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{sportnetId}', sportnetId.toString());
        queryParameters['limit'] = 100;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        if (typeof parameters['competitionId'] !== 'undefined') {
            queryParameters['competitionId'] = parameters['competitionId'];
        }
        queryParameters['competitionId'] = this.transformParameter(queryParameters['competitionId']);
        if (typeof parameters['competitionGroupId'] !== 'undefined') {
            queryParameters['competitionGroupId'] = parameters['competitionGroupId'];
        }
        queryParameters['competitionGroupId'] = this.transformParameter(queryParameters['competitionGroupId']);
        if (typeof parameters['partId'] !== 'undefined') {
            queryParameters['partId'] = parameters['partId'];
        }
        queryParameters['partId'] = this.transformParameter(queryParameters['partId']);
        if (typeof parameters['roundId'] !== 'undefined') {
            queryParameters['roundId'] = parameters['roundId'];
        }
        queryParameters['roundId'] = this.transformParameter(queryParameters['roundId']);
        if (typeof parameters['dateFrom'] !== 'undefined') {
            queryParameters['dateFrom'] = parameters['dateFrom'];
        }
        queryParameters['dateFrom'] = this.transformParameter(queryParameters['dateFrom']);
        if (typeof parameters['dateTo'] !== 'undefined') {
            queryParameters['dateTo'] = parameters['dateTo'];
        }
        queryParameters['dateTo'] = this.transformParameter(queryParameters['dateTo']);
        if (typeof parameters['closed'] !== 'undefined') {
            queryParameters['closed'] = parameters['closed'];
        }
        queryParameters['closed'] = this.transformParameter(queryParameters['closed']);
        if (typeof parameters['teamId'] !== 'undefined') {
            queryParameters['teamId'] = parameters['teamId'];
        }
        queryParameters['teamId'] = this.transformParameter(queryParameters['teamId']);
        if (typeof parameters['ids'] !== 'undefined') {
            queryParameters['ids'] = parameters['ids'];
        }
        queryParameters['ids'] = this.transformParameter(queryParameters['ids']);
        if (typeof parameters['sorter'] !== 'undefined') {
            queryParameters['sorter'] = parameters['sorter'];
        }
        queryParameters['sorter'] = this.transformParameter(queryParameters['sorter']);
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#getLatestTeamAppSpaceResultsTable
     */
    Api.prototype.getLatestTeamAppSpaceResultsTable = function (appSpace, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/team-competitions/{appSpace}/latest-resultsTable';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        if (typeof parameters['ownerPpo'] !== 'undefined') {
            queryParameters['ownerPPO'] = parameters['ownerPpo'];
        }
        queryParameters['ownerPPO'] = this.transformParameter(queryParameters['ownerPPO']);
        path = path.replace('{appSpace}', appSpace.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    return Api;
}());
exports.Api = Api;
exports["default"] = new Api();
